(() => {
  let timer;
  let controller;
  let sequence = 0;
  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-ww-menu-query]');
    if (!input) return;
    const form = input.closest('form');
    const panel = form.nextElementSibling;
    const query = input.value.trim();
    const request = ++sequence;
    clearTimeout(timer);
    controller?.abort();
    panel.replaceChildren();
    panel.hidden = true;
    if (query.length < 2) return;
    timer = setTimeout(async () => {
      controller = new AbortController();
      try {
        const url = new URL(panel.dataset.suggestUrl + '.json', location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '4');
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) return;
        const data = await response.json();
        if (request !== sequence || !input.isConnected) return;
        const list = document.createElement('div');
        list.className = 'ww-menu-results__list';
        (data.resources?.results?.products || []).slice(0, 4).forEach((product) => {
          const link = document.createElement('a');
          link.className = 'ww-menu-results__item';
          const destination = new URL(product.url, location.origin);
          if (destination.origin !== location.origin) return;
          link.href = destination.href;
          if (product.image) {
            const image = document.createElement('img');
            image.src = product.image;
            image.alt = '';
            image.width = 44;
            image.height = 44;
            link.append(image);
          }
          const title = document.createElement('span');
          title.textContent = product.title;
          link.append(title);
          list.append(link);
        });
        panel.append(list);
        if (!list.children.length) {
          const empty = document.createElement('p');
          empty.textContent = panel.dataset.emptyLabel.replace('__QUERY__', query);
          panel.append(empty);
        }
        panel.hidden = false;
      } catch (error) {
        if (error.name !== 'AbortError') panel.hidden = true;
      }
    }, 250);
  });
  document.addEventListener('keydown', (event) => {
    const input = event.target.closest('[data-ww-menu-query]');
    if (!input) return;
    const panel = input.closest('form').nextElementSibling;
    if (event.key === 'Escape' && !panel.hidden) {
      event.preventDefault();
      event.stopPropagation();
      panel.hidden = true;
    }
    if (event.key === 'ArrowDown' && !panel.hidden) {
      event.preventDefault();
      panel.querySelector('a')?.focus();
    }
  });
})();
